var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4846",
    "data-name": "Group 4846",
    transform: "translate(-2564.116 4554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4845",
    "data-name": "Group 4845",
    transform: "translate(-3173 11481)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12661",
    "data-name": "Rectangle 12661",
    width: 16,
    height: 2,
    transform: "translate(5737.116 -16035)",
    fill: "#a6acb5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12661-2",
    "data-name": "Rectangle 12661",
    width: 16,
    height: 2,
    transform: "translate(5737.116 -16031)",
    fill: "#a6acb5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12661-3",
    "data-name": "Rectangle 12661",
    width: 16,
    height: 2,
    transform: "translate(5737.116 -16027)",
    fill: "#a6acb5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowsIcon);
export default __webpack_public_path__ + "static/media/rows_icon.023be1f5b48e1c734a16f375f4a68668.svg";
export { ForwardRef as ReactComponent };